export const AUTO_PRINT_STORAGE_KEY = "talabatk:auto-print-configured";
